import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

/**
 * سربرگ مشترک مودال‌های سامانه؛ متکی به تم فعلی و بدون استایل سراسری جدید.
 */
export function AppDialogTitle({
  title,
  description,
  icon,
  children,
  onClose,
  closeDisabled = false,
  sx,
  ...other
}) {
  const customStyles = Array.isArray(sx) ? sx : [sx];

  return (
    <DialogTitle
      {...other}
      sx={[
        {
          pb: 2,
        },
        ...customStyles.filter(Boolean),
      ]}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0 }}>
          {icon && (
            <Box
              sx={{
                width: 40,
                height: 40,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                borderRadius: 1.5,
                color: 'primary.dark',
                bgcolor: 'primary.lighter',
              }}
            >
              <Iconify icon={icon} width={22} />
            </Box>
          )}

          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" component="div">
              {title}
            </Typography>
            {description && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {description}
              </Typography>
            )}
            {children && <Box sx={{ mt: 1 }}>{children}</Box>}
          </Box>
        </Stack>

        {onClose && (
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            disabled={closeDisabled}
            aria-label="بستن"
          >
            <Iconify icon="mingcute:close-line" />
          </IconButton>
        )}
      </Stack>
    </DialogTitle>
  );
}
